import React from 'react';

// Drawn inline so arrows keep one weight everywhere; as text characters,
// phones may swap them for emoji.
const paths = {
  'arrow-up-right': <path d="M7 17 17 7M8 7h9v9" />,
  'arrow-right': <path d="M5 12h14M13 6l6 6-6 6" />,
  'arrow-up': <path d="M12 19V5M6 11l6-6 6 6" />,
  minus: <path d="M6 12h12" />,
  reset: <path d="M4.5 12a7.5 7.5 0 1 0 2.4-5.5M4.5 4.5v4.4h4.4" />,
  stop: (
    <rect
      x="7.5"
      y="7.5"
      width="9"
      height="9"
      rx="1.5"
      fill="currentColor"
      stroke="none"
    />
  ),
};

export type IconName = keyof typeof paths;

export default function Icon({ name }: { name: IconName }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {paths[name]}
    </svg>
  );
}
